import useSWR from 'swr';
import { AdminSettingsService } from '@/services/engine/admin-settings-service';
import type { MembersPaginatedResponse } from '@/types/admin-settings';

const CACHE_KEY = 'admin-members';

export function useMembers(size = 20, page = 1, name?: string) {
    const { data, isLoading, error, mutate } = useSWR<MembersPaginatedResponse>(
        [CACHE_KEY, page, size, name ?? ''],
        () => AdminSettingsService.getMembers({ page, size, name }),
        { revalidateOnFocus: false, keepPreviousData: true },
    );

    return {
        members: data?.items ?? [],
        total: data?.page.totalItems ?? 0,
        isLoaded: !!data,
        isLoading,
        error,
        mutate,
    };
}
